import React, { useState, useEffect, useCallback } from 'react'

import { Form, Input, Col, Row, Toggle } from 'rsuite'
import DropzonePreview from '@components/common/form/DropzonePreview'
import { ensureUrlProtocol } from '@@partner:helpers/util'

export interface StorySlidesProps {
  value: any
  index: number
  onChange: (index: number, slide: any) => void
  onDelete: () => void
}

export default function SlidesForm ({
  value,
  index,
  onChange,
  onDelete
}: StorySlidesProps) {
  const makeSaveHandler = (key: string) => (newData: any) => {
    onChange(index, {
      ...value,
      [key]: newData
    })
  }

  return (
    <Row className="border rounded-md mb-4 mr-4 p-1" key={value.image_id}>
      <Col className="border rounded-md py-2 px-2">
        <Form.Group style={{ marginBottom: '0' }}>
          <DropzonePreview url={value?.image?.url} onDelete={onDelete} />
        </Form.Group>
      </Col>
      <Col md={16}>
        <Form.Group>
          <Form.ControlLabel>Позиция</Form.ControlLabel>

          <Input
            placeholder="Позиция слайда в истории"
            name="sort_order"
            className="pb-2"
            value={value.sort_order || 0}
            onChange={makeSaveHandler('sort_order')}
          />
        </Form.Group>

        <Form.Group>
          <Form.ControlLabel>Ссылка</Form.ControlLabel>

          <Input
            placeholder="Ссылка"
            name="url"
            className="pb-2"
            value={value.url || ''}
            onChange={makeSaveHandler('url')}
            onBlur={(event) =>
              makeSaveHandler('url')(ensureUrlProtocol(event.target.value))
            }
          />
        </Form.Group>

        <Form.Group>
          <Form.ControlLabel>Открывать в браузере</Form.ControlLabel>

          <Form.Control
            accepter={Toggle}
            size="lg"
            name="optionOpenInBrowser"
            checked={value.optionOpenInBrowser}
            value={value.optionOpenInBrowser}
            onChange={makeSaveHandler('optionOpenInBrowser')}
          />
        </Form.Group>

        <Form.Group>
          <Form.ControlLabel>Открывать в новом окне</Form.ControlLabel>

          <Form.Control
            accepter={Toggle}
            size="lg"
            name="optionOpenInNewWindow"
            checked={value.optionOpenInNewWindow}
            value={value.optionOpenInNewWindow}
            onChange={makeSaveHandler('optionOpenInNewWindow')}
          />
        </Form.Group>
      </Col>
    </Row>
  )
}
